import { CurrencyInput } from '@/components/ui/currency-input';
import { centsToInitialValue, currencyInputValueToCents } from '@/lib/currency';
import { pdkAxios } from '@/lib/pdk-axios';
import type { Trade } from '@/models/types';
import { tradesStore } from '@/stores/trades-store';
import { useMutation } from '@tanstack/react-query';
import { debounce } from 'lodash';
import { useCallback, useEffect, useState } from 'react';

const TradeVehiclePayoffAmountEditor = ({
  tradeId,
  initialPayoffAmount,
}: {
  tradeId: Trade['id'];
  initialPayoffAmount: number;
}) => {
  const [payoffAmount, setPayoffAmount] = useState(initialPayoffAmount);

  const updatePayoffAmountMutation = useMutation({
    onMutate: async ({ payoffAmount }: { payoffAmount: number }) => {
      tradesStore.updateTrade(tradeId, {
        payoff_amount: payoffAmount,
      });
    },
    mutationFn: async ({ payoffAmount }: { payoffAmount: number }) => {
      const response = await pdkAxios.post(
        `/trades/${tradeId}/payoff_amount`,
        // /api/trades/:trade_id/payoff_amount
        {
          payoff_amount: payoffAmount,
        },
      );

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error updating payoff amount', error, variables);
      // TODO: handle error by adding the original cdkId back to the store
    },
  });

  const handlePayoffAmountChange = useCallback(
    debounce((newPayoffAmount: number) => {
      // toast({
      //   title: 'Mileage change not implemented',
      //   description: `Mileage change is not implemented yet. ${newMileage}`,
      // });
      updatePayoffAmountMutation.mutate({
        payoffAmount: newPayoffAmount,
      });
    }, 1000),
    [],
  );

  useEffect(() => {
    if (payoffAmount === initialPayoffAmount) return;

    handlePayoffAmountChange(payoffAmount);
  }, [payoffAmount]);

  const onChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (isNaN(Number(e.target.value))) return;

    setPayoffAmount(currencyInputValueToCents(e.target.value));
  }, []);

  useEffect(() => {
    setPayoffAmount(initialPayoffAmount);
  }, [initialPayoffAmount]);

  return (
    <div className="flex flex-row gap-1 items-center justify-between">
      <div className="flex flex-row gap-1 items-center">
        <div className="text-sm text-gray-500 dark:text-white">
          Payoff Amount
        </div>
      </div>
      <CurrencyInput
        className="rounded text-xs text-right"
        placeholder="Add Payoff Amount"
        value={centsToInitialValue(payoffAmount)}
        onChange={onChange}
      />
    </div>
  );
};

export default TradeVehiclePayoffAmountEditor;
